import pdfMake from 'pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import figureFormatter from "@/services/utils/figureFormatter";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

pdfMake.fonts = {
    SulaimanLipi: {
        normal: 'https://fonts.cdnfonts.com/s/14639/solaimanlipi.woff',
        bold: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf',
        italics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf',
        bolditalics: 'https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf'
    }
}
const appointmentPdfPrinter = () => {
    const { commaFormat } = figureFormatter();

    const exportToPDF = (ap, payHead = []) => {
        var doc = {
            pageSize: 'A4',
            pageMargins: [ 30, 50, 30, 10 ],
            content: getContent(ap, payHead),

            styles : {
                header: {
                    fontSize: 24,
                }
            },
            defaultStyle: {
                color: 'black',
                fontSize: 10,
                font: 'SulaimanLipi'
            },
            info: {
                title: ap.type == 'offer_letter' ? 'Offer Letter' : 'Appointment Letter',
            }
        }

        const pdfDocGenerator = pdfMake.createPdf(doc);
        pdfDocGenerator.open();
    }

    const getContent = (ap, payHead) => {
        let salaryTypeData = payHead[0] ?? []
        return  [
                {
                    text: ap.type == 'offer_letter' ? 'Offer Letter' : 'Appointment Letter',
                    style: 'header',
                    alignment: 'center',
                    margin: [0, 0, 5, 10],
                    bold: true,
                    color: 'black',
                },

                {
                    margin: [0, 5, 0, 0],
                    alignment: 'justify',
                    columns: [
                        {
                            width: '100%',
                            stack: [
                                (ap.formatted_date)
                                    ? {
                                    text: [
                                        {
                                            text: 'Date:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.formatted_date
                                        }
                                    ],
                                } : null,
                                (ap.appointment_ref)
                                    ? {
                                    text: [
                                        {
                                            text: 'Ref #:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.appointment_ref
                                        }
                                    ],
                                } : null,
                                (ap.user_name)
                                    ? {
                                    text: [
                                        {
                                            text: 'Name:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.user_name
                                        }
                                    ],
                                } : null,
                                (ap.area)
                                    ? {
                                    text: [
                                        {
                                            text: 'Address:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.area
                                        }
                                    ],
                                 } : null,
                                (ap.user_phone)
                                    ? {
                                    text: [
                                        {
                                            text: 'Mobile No:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.user_phone
                                        }
                                    ],
                                } : null,
                                (ap.user_email)
                                    ? {
                                    text: [
                                        {
                                            text: 'Email:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.user_email
                                        }
                                    ],
                                 } : null,

                                (ap.formatted_date_of_birth)
                                    ? {
                                    text: [
                                        {
                                            text: 'Date of Birth:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.formatted_date_of_birth
                                        }
                                    ],
                                } : null,

                            ]

                        },

                    ]
                },

               (ap.designation_name)
                ? {
                    alignment: 'justify',
                    margin: [0, 5],
                    text: [
                        { text:  (ap.type == 'offer_letter' ? 'Offer' : 'Appointment') + ' letter for the position of ', bold: true },
                        { text: ap.designation_name, bold: true }
                    ]
                } : null,

                {
                    alignment: 'justify',
                    margin: [0, 5],
                    text: [
                        { text: `Dear ${ap.user_name}, 
                                 We are pleased to offer you, the position of ${ap.designation_name} with ${ap.company_name} on the following terms and conditions:`},
                    ]
                },

                {
                    alignment: 'justify',
                    margin: [0, 5],
                    text: [
                        { text: 'Employment Details  ', bold: true, fontSize: 12 },
                    ]
                },

                {
                    margin: [0, 5, 0, 0],
                    alignment: 'justify',
                    columns: [
                        {
                            width: '100%',
                            stack: [
                                (ap.designation_name)
                                    ? {
                                    text: [
                                        {
                                            text: 'Designation:',
                                            bold: true,
                                        },

                                        {
                                            text: ap.designation_name
                                        }
                                    ],
                                } : null,
                                (ap.department_name)
                                    ? {
                                    text: [
                                        {
                                            text: 'Department:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.department_name
                                        }
                                    ],
                                 } : null,
                                (ap.employee_category_name)
                                    ? {
                                    text: [
                                        {
                                            text: 'Employment Type:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.employee_category_name
                                        }
                                    ],
                                 } : null,
                                (ap.area_name)
                                    ? {
                                    text: [
                                        {
                                            text: 'Work Location:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.area_name
                                        }
                                    ],
                                  } : null,
                                (ap.supervisor_name)
                                    ? {
                                    text: [
                                        {
                                            text: 'Reporting To:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.supervisor_name
                                        }
                                    ],
                                 } : null,
                                (ap.formatted_date_of_joining)
                                    ? {
                                    text: [
                                        {
                                            text: 'Date of Joining:  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.formatted_date_of_joining
                                        }
                                    ],
                                  } : null,

                                (ap.probation_period)
                                 ? {
                                    text: [
                                        {
                                            text: 'Probation Period(Month):  ',
                                            bold: true,
                                        },

                                        {
                                            text: ap.probation_period
                                        }
                                    ],
                                } : null,

                                (ap.gross_salary && ap.type === 'offer_letter')
                                    ? {
                                        text: [
                                            { text: 'Gross Salary:   ', bold: true },
                                            { text: commaFormat(ap.gross_salary) }
                                        ]
                                    }
                                    : null

                            ]

                        },

                    ]
                },

            ...(ap.type === 'appointment_letter' ? [
                {
                    alignment: 'justify',
                    margin: [0, 5],
                    text: [
                        { text: 'Salary & Benefits Details', bold: true, fontSize: 12 },
                    ]
                },
                {
                    margin: [0, 5, 0, 0],
                    alignment: 'justify',
                    columns: [
                        {
                            width: '100%',
                            stack: [
                                (salaryTypeData.salary_type_name) && {
                                    text: [
                                        { text: 'Salary Type: ', bold: true },
                                        { text: salaryTypeData.salary_type_name }
                                    ],
                                },
                                (salaryTypeData.scale_amount && salaryTypeData.grade_number) && {
                                    text: [
                                        { text: 'Salary Grade Scale: ', bold: true },
                                        { text: `${salaryTypeData.grade_number} (${salaryTypeData.scale_amount})` }
                                    ],
                                },
                            ].filter(Boolean)
                        },
                    ]
                },
                {
                    columns: [
                        {
                            width: '50%',
                            table: {
                                widths: ['*', 'auto'],
                                body: [
                                    [
                                        { text: 'Pay Head', style: 'tableHeader' },
                                        { text: 'Amount', style: 'tableHeader' }
                                    ],
                                    ...payHead.map(item => ([
                                        { text: item.pay_head_name },
                                        { text: commaFormat(item.pay_head_amount), alignment: 'right' }
                                    ]))
                                ]
                            },
                            layout: {
                                fillColor: function (rowIndex, node, columnIndex) {
                                    return (rowIndex === 0) ? '#f3f2f7' : null;
                                },
                                hLineWidth: function () { return 0.5; },
                                vLineWidth: function () { return 0.5; }
                            }
                        }
                    ],
                    margin: [0, 10, 0, 0]
                }
            ] : []),

            {
                    alignment: 'justify',
                    margin: [0, 5],
                    text: [
                        { text: 'Job Description: \n', bold: true, fontSize: 12 },
                        {
                            margin: [10],
                            text: [
                                {text: getTerms(ap.job_description)}
                            ]
                        }
                    ]
                },

                {
                    alignment: 'justify',
                    margin: [0, 5],
                    text: [
                        { text: 'Employment Terms & Conditions: \n', bold: true, fontSize: 12 },
                        {
                            margin: [10],
                            text: [
                                {text: 'Please find enclosed the Employment Terms & Conditions document, which forms an integral part of this appointment.' +
                                        'You are advised to read it carefully. Your acceptance of this appointment implies acceptance of the terms set out therein. \n\n ' +
                                        'Please confirm your acceptance of this Contract of Employment by signing and returning the duplicate copy. \n' +
                                        'We welcome you, and look forward to receiving your acceptance and to working with you.'}
                            ]
                        }
                    ]
                },

                {
                    alignment: 'justify',
                    margin: [0, 5],
                    text: [
                        { text: 'Yours Sincerely,'}
                    ]
                },

                formatApproverSign(),

               {
                alignment: 'justify',
                margin: [0, 5],
                stack: [
                    {
                        text: 'Acknowledgement & Acceptance',
                        bold: true,
                        fontSize: 12,
                        margin: [0, 0, 0, 10]
                    },
                    {
                        columns: [
                            {
                                text: [
                                    'I, ',
                                    {
                                        text: '_____________________',
                                        decoration: 'underline'
                                    },
                                    ' hereby accept the appointment and confirm that I have read and understood the enclosed Employment Terms & Conditions.'
                                ],
                                margin: [0, 0, 0, 15]
                            },
                        ],
                        columnGap: 5,
                        margin: [0, 0, 0, 15]
                    },
                    {
                        canvas: [
                            { type: 'line', x1: 0, y1: 0, x2: 100, y2: 0, lineWidth: 1 }
                        ]
                    },
                    {
                        text: 'Signature & Date',
                        margin: [0, 5, 0, 0],
                        bold: true
                    }
                ]
            }

        ]
    }

    const formatApproverSign = () => {

        let signatures = ['Approvar Sign & Date'];

        return {
            alignment: 'justify',
            margin: [0, 10],
            columns: signatures.map(getStaticSingleSignature)
        }
    }

    const getStaticSingleSignature = (title) => {
        return {
            width: '43%',
            stack: [
                {
                    canvas: [
                        {
                            type: 'line',
                            x1: 0,
                            y1: 0,
                            x2: 100,
                            y2: 0,
                            lineWidth: 1
                        }
                    ]
                },
                {
                    margin: [ 0, 5, 0, 0 ],
                    text: `${title} `,
                    color: 'black',
                    bold: true,
                    alignment: 'left',
                }
            ]
        }
    }

    const getTerms = (notes) => {
        if (!Array.isArray(notes) || notes.length === 0) return '';
        return notes.map((item, index) => `${index + 1}. ${item}`).join('\n');
    };

    return {
        exportToPDF
    }
}

export default appointmentPdfPrinter;
